import React from 'react';

import { node, string, func, bool } from 'prop-types';

import { SDPStealthLogoGray } from 'Assets';

export default function Page({
  children = <></>,
  headerChildren,
  headerCustomClass = '',
  shouldUseInnerWrap = true,
  isLogo
}) {
  return (
    <div
      className="sdp-content-area flex flex-column"
      style={{
        overflow: shouldUseInnerWrap ? 'auto' : 'hidden'
      }}
      data-testid="page-component"
    >
      <header
        className={`sdp-page-header ${headerCustomClass}`}
        data-testid="page-component_header"
      >
        {isLogo ? <img src={SDPStealthLogoGray} alt="logoHeaderSdp" /> : ''}
        {headerChildren}
      </header>
      {shouldUseInnerWrap ? (
        <div
          className="sdp-inner-wrapper"
          data-testid="page-component_inner-wrap"
        >
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}

Page.propTypes = {
  children: node,
  headerChildren: node,
  shouldUseInnerWrap: func,
  headerCustomClass: string,
  isLogo: bool
};

Page.defaultProps = {
  children: <></>,
  headerChildren: <></>,
  shouldUseInnerWrap: () => {},
  headerCustomClass: '',
  isLogo: false
};
